<template>
  <div class="dropdown">
    <button
      class="btn btn-dropdown dropdown-toggle"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      :disabled="disabled"
    >
      {{ selectedItem === 'customDate' && customLabel ? customLabel : $t(`flexigo.date.${selectedItem}`) }}
    </button>
    <ul class="dropdown-menu">
      <li v-for="row in dropdownData" :key="row">
        <a class="dropdown-item" href="#" @click.prevent="onLinkClick(row)">{{ $t(`flexigo.date.${row}`) }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { getDateRangeByType } from '@/helpers/dateTime';

export default {
  props: {
    value: {
      type: String,
    },
    newDays: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    customLabel: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedItem: 'today',
      clickedItem: undefined,
      days: [
        'today',
        'yesterday',
        'thisMonth',
        'lastSevenDays',
        'lastMonth',
        'lastThirtyDays',
        'thisWeek',
        'customDate',
      ],
    };
  },
  computed: {
    dropdownData() {
      if (this.newDays) {
        return this.newDays;
      }
      return this.days;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue !== this.selectedItem) {
          this.selectedItem = newValue;
        }
      },
    },
    clickedItem(newValue) {
      this.selectedItem = newValue;
    },
    selectedItem(newValue) {
      const formatted = getDateRangeByType(newValue);
      switch (newValue) {
        case 'customDate':
          this.$emit('show-custom-range', true);
          break;
        default:
      }
      this.$emit('input', newValue);

      if (newValue !== 'customDate') {
        this.$emit('date-changed', formatted);
        this.$emit('show-custom-range', false);
      }
    },
  },
  mounted() {
    this.selectedItem = this.value ?? 'today';
  },
  methods: {
    onLinkClick(row) {
      if (row === 'customDate' && this.selectedItem === row) {
        this.$emit('show-custom-range', true);
        return;
      }
      this.selectedItem = row;
    },
  },
};
</script>

<style></style>
